import { Box, Button, Modal, Typography, useMediaQuery } from "@mui/material";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { MdOutlineClose } from "react-icons/md";
import ReactMarkdown from "react-markdown";
import { useMutation, useQuery } from "react-query";
import remarkGfm from "remark-gfm";
import Footer from "../../components/Home/Footer";
import Header from "../../components/Layout/Header";
import { STRAPI_API_URL } from "../../src/constant/appConstants";
import fetcher from "../../src/dataProvider";
import eventBus from "../../util/eventBus";
import { verifyEmail, verifyMobile, verifyUrl } from "../../util/validators";
import { makeStyles } from "@mui/styles";
import router from "next/router";
import auth from "../../components/Layout/util/auth";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { influencerPageGTMCTAClick } from "../../util/gtmutil";

const useStyles = makeStyles((theme) => ({
  otpContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "515px",
    background: "#fff",
    borderRadius: "12px",
    padding: "43px 50px",
    marginBottom: "40px",
    "& h5": {
      fontSize: "24px",
      fontWeight: "700",
      textAlign: "center",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      textAlign: "center",
    },
    "& img": {
      float: "right",
      marginBottom: "20px",
      cursor: "pointer",
    },
    "& a": {
      color: "#E14084",
    },
  },
  otpInputs: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0",
    margin: "34px 0 24px",
    "& input": {
      width: "56px",
      height: "56px",
      lineHeight: "56px",
      textAlign: "center",
      borderRadius: "12px",
      border: "1px solid #ccc",
      fontSize: "24px",
      fontWeight: "400",
    },
  },
  btnNext: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    maxWidth: "346px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    margin: "25px auto 0",
    borderRadius: "12px",
    height: "56px",
    color: "#fff",
    textDecoration: "none",
    textTransform: "capitalize",
    "&:hover": {
      color: "#fff",
      textDecoration: "none",
    },
    "@media(max-width:992px)": {
      margin: "auto",
    },
  },
}));

export default function Influencers() {
  const [expanded, setExpanded] = useState(false);
  const handlePanel = (panel) => {
    let panelDt = expanded === panel ? 0 : panel;
    setExpanded(panelDt);
  };
  const classes = useStyles();
  const { userData } = useSelector((state) => state.user);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const initialValues = {
    email: "",
    mobile: "",
    profileLink: "",
    songLink: "",
    username: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [successModal, setSuccessModal] = useState(false);
  const [influencersQuestion, setInfluencersQuestion] = useState("");

  const { data: faqData } = useQuery(`${STRAPI_API_URL}/faq-categories`, () =>
    fetcher.get(`${STRAPI_API_URL}/faq-categories`, {
      params: {
        [`filters[category_title][$eq]`]: "InfluencerCampaignFAQ",
        populate: "*",
      },
    })
  );

  useEffect(() => {
    if (faqData) {
      setInfluencersQuestion(faqData.data[0].attributes.faq_questions);
    }
  }, [faqData]);

  const r = auth();
  const handleJoinAsInfluencer = () => {
    if (isEmpty(r.token)) {
      influencerPageGTMCTAClick(
        r,
        "Join as Influencer",
        "Influencer",
        "Join as Influencer",
        "loggedIn",
        "Guest"
      );
      eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
    } else if (userData.role != "influencer") {
      influencerPageGTMCTAClick(
        r,
        "Join as Influencer Start",
        "Influencer",
        "Join as Influencer",
        "loggedIn",
        "Guest"
      );
      router.push("influencers/profile");
    }
  };
  const handleJoinAsCampaign = () => {
    if (userData?.role == "influencer") {
      influencerPageGTMCTAClick(
        r,
        "Join live campaign",
        "Influencer",
        "Join as Influencer",
        "loggedIn",
        "Guest"
      );
      router.push("campaign/listing");
    } else {
      influencerPageGTMCTAClick(
        r,
        "Join as Influencer Start",
        "Influencer",
        "Join as Influencer",
        "loggedIn",
        "Guest"
      );
      router.push("influencers/profile");
    }
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <div>
      <Header />
      <div className="main-section2">
        <div className="artist-baner">
          <div className="art-banner" style={{ marginTop: "70px" }}>
            <p>FanTiger for Influencer</p>
            <h1 style={{ marginTop: "45px" }}>
              Earn Royalty*
              <br /> Win Rewards with <br />
              On-Demand Collabrations
            </h1>
            <p> Instantly, and directly collaborate with music artists</p>
            <div className="btnContainer">
              {(isEmpty(r.token) || userData?.role != "influencer") && (
                <Button
                  onClick={() => handleJoinAsInfluencer()}
                  variant="contained"
                  className="btnInfluencer"
                >
                  Join as Influencer
                </Button>
              )}
              {userData?.role == "influencer" && (
                <Button
                  variant={isMobile ? "contained " : "outlined"}
                  className={isMobile ? "btnInfluencer " : "btnCompain"}
                  onClick={() => handleJoinAsCampaign()}
                >
                  Join Live Campaign
                </Button>
              )}
            </div>
          </div>
          <div className="art-bannerImg">
            <Box component="img" src="./images/influencer/banner.svg"></Box>
          </div>
        </div>
      </div>
      <section className="sec-section-2">
        <h1 className="sec-section-2-head">Getting Started</h1>
        <div className="container01">
          <div className="card02-view">
            <div className="card card02">
              <div className="tab-sec">
                <img src="./images/home/steps/icon-1.svg" alt="" />
              </div>
            </div>
            <div className="card02-disc">
              <h1>Participate in Campaigns</h1>
              <p>
                Participate in song campaigns by creating Reels / Videos on
                Instagram
              </p>
            </div>
          </div>
          <div className="card02-view">
            <div className="card card02">
              <div className="tab-sec">
                <img src="./images/home/steps/icon-2.svg" alt="" />
              </div>
            </div>
            <div className="card02-disc">
              <h1>{"Earn & Get Ownership in Songs"}</h1>
              <p>
                Influencers earn money and ownership in the song based on the
                performance on Reels / Videos
              </p>
            </div>
          </div>
          <div className="card02-view">
            <div className="card card02">
              <div className="tab-sec">
                <img src="./images/home/steps/icon-3.svg" alt="" />
              </div>
            </div>
            <div className="card02-disc">
              <h1>Win as a Team</h1>
              <p>
                Influencers earn royalties forthe songs they participate in.
                When artists grow, everyone wins.
              </p>
            </div>
          </div>
        </div>
        <div className="faq-sec">
          <h1 className="sec-section-2-head">FAQS</h1>
          <div className="accordion-wrapper">
            {influencersQuestion &&
              influencersQuestion?.data?.map((item) => {
                return (
                  <div
                    className={
                      expanded === item.id + 1 ? "accordion show" : "accordion"
                    }
                    key={item.id}
                  >
                    <div
                      className="accordion-label"
                      onClick={() => handlePanel(item.id + 1)}
                    >
                      {item?.attributes.question}
                    </div>
                    <div className="accordion-content">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {item?.attributes.answer}
                      </ReactMarkdown>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <Modal
          open={successModal}
          onClose={() => {
            setSuccessModal(false);
          }}
        >
          <>
            <div className="successModal_influencer">
              Your application is submitted successfully
            </div>
            <div
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "205px",
                left: "1290px",
                cursor: "pointer",
              }}
              onClick={() => {
                setSuccessModal(false);
              }}
            >
              <MdOutlineClose size={24} color="#000000" />
            </div>
          </>
        </Modal>
      </section>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box className={classes.otpContainer}>
          <Box
            component="img"
            onClick={handleClose}
            src="/images/community/close.svg"
          />
          <Typography variant="h5">OTP VErification</Typography>
          <Typography component="p">
            Enter the OTP sent to {userData?.mobile}{" "}
            {/* <Link href="#">(edit)</Link> */}
          </Typography>
          <Box className={classes.otpInputs}>
            <input type="text" placeholder="*" />
            <input type="text" placeholder="*" />
            <input type="text" placeholder="*" />
            <input type="text" placeholder="*" />
          </Box>
          <Typography component="p" className="text-right">
            {/* {"Don't receive code? "}
            <Link href="#">Re-send</Link> */}
          </Typography>
          <Button type="submit" className={classes.btnNext}>
            Submit
          </Button>
        </Box>
      </Modal>
      <Footer />
    </div>
  );
}
